/* eslint-disable no-unused-vars */
import React from 'react'
import { Text } from '../'
import { ItensDiv, ContainerFeatureList } from './index.styled'

import AuthanticEmbossedTexture from './../../assets/icons/pictogramas/authantic-embossed-texture.svg'
import BiophilicDesign from './../../assets/icons/pictogramas/biophilic-design.svg'
import CorkBenefits from './../../assets/icons/pictogramas/cork-benefits.svg'
import CorkInside from './../../assets/icons/pictogramas/cork-inside.svg'
import Customization from './../../assets/icons/pictogramas/customization.svg'
import DigitalPrintingTechnology from './../../assets/icons/pictogramas/digital-printing-technology.svg'
import DomesticUse from './../../assets/icons/pictogramas/domestic-use.svg'
import Durable from './../../assets/icons/pictogramas/durable.svg'
import EasyInstallation5Gi from './../../assets/icons/pictogramas/easy-installation-5Gi.svg'
import EasyInstallation from './../../assets/icons/pictogramas/easy-installation.svg'
import EasyToClean from './../../assets/icons/pictogramas/easy-to-clean.svg'
import EngineeredWood from './../../assets/icons/pictogramas/engineered-wood.svg'
import ExtraComfortDekwall from './../../assets/icons/pictogramas/extra-comfort-dekwall.svg'
import ExtraComfort from './../../assets/icons/pictogramas/extra-comfort.svg'
import FireResistance from './../../assets/icons/pictogramas/fire-resistance.svg'
import FitOnUnevenSurfaces from './../../assets/icons/pictogramas/fit-on-uneven-surfaces.svg'
import FloorAndWallConcept from './../../assets/icons/pictogramas/floor-and-wall-concept.svg'
import GlueDown from './../../assets/icons/pictogramas/glue-down.svg'
import HeavyTraffic31 from './../../assets/icons/pictogramas/heavy-traffic-31.svg'
import HeavyTraffic33 from './../../assets/icons/pictogramas/heavy-traffic-33.svg'
import HerringbonePatternOption from './../../assets/icons/pictogramas/herringbone-pattern-option.svg'
import HighResistanceVarnish from './../../assets/icons/pictogramas/high-resistance-varnish.svg'
import HighResolutionDesigns from './../../assets/icons/pictogramas/high-resolution-designs.svg'
import HighlyRealisticDesigns from './../../assets/icons/pictogramas/highly-realistic-designs.svg'
import IdealForRenovations from './../../assets/icons/pictogramas/ideal-for-renovations.svg'
import ImprovedFireResistance from './../../assets/icons/pictogramas/improved-fire-resistance.svg'
import IndoorAirQuality from './../../assets/icons/pictogramas/indoor-air-quality.svg'
import Instalation from './../../assets/icons/pictogramas/instalation.svg'
import LargeInstallationAreas from './../../assets/icons/pictogramas/large-installation-areas.svg'
import LongerPlanks from './../../assets/icons/pictogramas/longer-planks.svg'
import LowThickness from './../../assets/icons/pictogramas/low-thickness.svg'
import LowerRepetitionLevel from './../../assets/icons/pictogramas/lower-repetition-level.svg'
import Manutencao20 from './../../assets/icons/pictogramas/manutencao-20.svg'
import NegativeCarbonBalance from './../../assets/icons/pictogramas/negative-carbon-balance.svg'
import PerformanceOnBudget from './../../assets/icons/pictogramas/performance-on-budget.svg'
import Performance from './../../assets/icons/pictogramas/performance.svg'
import PvcFree from './../../assets/icons/pictogramas/pvc-free.svg'
import Reparacao from './../../assets/icons/pictogramas/reparacao.svg'
import SoundReduction from './../../assets/icons/pictogramas/sound-reduction.svg'
import sustainable from './../../assets/icons/pictogramas/sustainable.svg'
import texturePlus from './../../assets/icons/pictogramas/texture-plus.svg'
import UniqueDesigns from './../../assets/icons/pictogramas/unique-designs.svg'
import UniqueInteriorDesignPossibilities from './../../assets/icons/pictogramas/unique-interior-design-possibilities.svg'
import UniqueVisuals from './../../assets/icons/pictogramas/unique-visuals.svg'
import ValueForMoney from './../../assets/icons/pictogramas/value-for-money.svg'
import Waterproof16 from './../../assets/icons/pictogramas/waterproof-16.svg'
import WoodVisualsInAPrintedFilm from './../../assets/icons/pictogramas/wood-visuals-in-a-printed-film.svg'


const FeatureListComponent = ({ sellingPoints = [] }) => {

  const getImage = (tag) => {
    switch (tag) {
      case 'game.selling-points.unique-designs':
        return UniqueDesigns;
      case 'gama.selling-points.unique-designs':
        return UniqueDesigns;
      case 'gama.selling-points.unique-visuals':
        return UniqueVisuals;
      case 'game.selling-points.extra-comfort':
        return ExtraComfort;
      case 'gama.selling-points.accoustic-insulator-walking-comfort':
        return ExtraComfort;
      case 'gama.selling-points.low-thickness':
        return LowThickness;
      case 'gama.selling-points.low-thickness-high-performance-floor':
        return LowThickness;
      case 'gama.selling-points.easy-to-install':
        return EasyInstallation;
      case 'gama.selling-points.easy-installation':
        return EasyInstallation;
      case 'gama.selling-points.100-cork':
        return CorkInside;
      case 'gama.selling-points.sustainable':
        return sustainable;
      case 'game.selling-points.sustainable':
        return sustainable;
      case 'gama.selling-points.sustainable-wallcoverings':
        return sustainable;
      case 'gama.selling-points.high-resolution-designs':
        return HighResolutionDesigns;
      case 'gama.selling-points.digital-printing-technology':
        return DigitalPrintingTechnology;
      case 'gama.selling-points.visuals-are-made-through-a-high-quality-digital-printing':
        return DigitalPrintingTechnology;
      case 'gama.selling-points.high-realistc-designs':
        return HighlyRealisticDesigns;
      case 'gama.selling-points.floor-and-wall-concept':
        return FloorAndWallConcept;
      case 'gama.selling-points.cork-Benefits':
        return CorkBenefits;
      case 'gama.selling-points.authantic-embossed-texture':
        return AuthanticEmbossedTexture;
      case 'gama.selling-points.biophilic-design':
        return BiophilicDesign;
      case 'gama.selling-points.customization':
        return Customization;
      case 'gama.selling-points.domestic-use':
        return DomesticUse;
      case 'gama.selling-points.durable':
        return Durable;
      case 'gama.selling-points.easy-installation-5gi':
        return EasyInstallation5Gi;
      case 'gama.selling-points.easy-to-clean':
        return EasyToClean;
      case 'gama.selling-points.engineered-wood':
        return EngineeredWood;
      case 'gama.selling-points.extra-comfort':
        return ExtraComfortDekwall;
      case 'gama.selling-points.extra-comfort-dekwall':
        return ExtraComfortDekwall;
      case 'gama.selling-points.fire-resistance':
        return FireResistance;
      case 'gama.selling-points.fit-on-uneven-surfaces':
        return FitOnUnevenSurfaces;
      case 'gama.selling-points.glue-down':
        return GlueDown;
      case 'gama.selling-points.heavy-traffic':
        return HeavyTraffic31;
      case 'gama.selling-points.heavy-traffic-33':
        return HeavyTraffic33;
      case 'gama.selling-points.herringbone-pattern-option':
        return HerringbonePatternOption;
      case 'gama.selling-points.high-resistance-varnish':
        return HighResistanceVarnish;
      case 'gama.selling-points.uses-a-high-resistant-varnish-as-a-wear-layer':
        return HighResistanceVarnish;
      case 'gama.selling-points.ideal-for-renovations':
        return IdealForRenovations;
      case 'gama.selling-points.improved-fire-resistance':
        return ImprovedFireResistance;
      case 'gama.selling-points.indoor-air-quality':
        return IndoorAirQuality;
      case 'gama.selling-points.instalation':
        return Instalation;
      case 'gama.selling-points.large-installation-areas':
        return LargeInstallationAreas;
      case 'gama.selling-points.longer-planks':
        return LongerPlanks;
      case 'gama.selling-points.lower-repetition-level':
        return LowerRepetitionLevel;
      case 'gama.selling-points.manutencao20':
        return Manutencao20;
      case 'gama.selling-points.negative-carbon-balance':
        return NegativeCarbonBalance;
      case 'gama.selling-points.performance-on-a-budget':
        return PerformanceOnBudget;
      case 'gama.selling-points.perfomance':
        return Performance;
      case 'gama.selling-points.performance':
        return Performance;
      case 'gama.selling-points.pvc-free':
        return PvcFree;
      case 'gama.selling-points.reparacao':
        return Reparacao;
      case 'gama.selling-points.sound-reduction-17db':
        return SoundReduction;
      case 'gama.selling-points.texture-plus':
        return texturePlus;
      case 'gama.selling-points.unique-interior-design-poosibilities':
        return UniqueInteriorDesignPossibilities;
      case 'gama.selling-points.unique-interior-design-possibilities':
        return UniqueInteriorDesignPossibilities;
      case 'gama.selling-points.value-for-money':
        return ValueForMoney;
      case 'gama.selling-points.waterproof':
        return Waterproof16;
      case 'gama.selling-points.visuals-are-achieved-through-a-printed-film':
        return WoodVisualsInAPrintedFilm;
      default:
        return null;
    }
  }

  return (
    <ContainerFeatureList>
      {sellingPoints.map((x, i) => {
        return (
          <ItensDiv key={i}>
            <img alt={i} src={getImage(x)}></img>
            <Text
              className="d-inline"
              fontFamily=""
              fontSize="16px"
              textId={x}
            />
          </ItensDiv>
        )
      })}
    </ContainerFeatureList>
  )
}

export default FeatureListComponent;
